import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './Text.scss';
import './App.scss';

import Sizer from './Sizer';

import { Route, Navigate, Routes, useLocation, Outlet, useParams } from 'react-router-dom';
import { checkAuth } from 'containers/Login/state/actions';

import PasswordRecovery from './pages/PasswordRecovery';
import ScanningPrivacy from './pages/ScanningPrivacy';
import Notifications from 'pages/Notifications';
import Registration from './pages/Registration';
import Contacts from './pages/Contacts';
import Tickets from './pages/MyTickets';
import Profile from './pages/Profile';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import Terms from './pages/Terms';
import Event from './pages/Event';
import Help from './pages/Help';
import Home from './pages/Home';
import Test from './pages/Test';

import WebShop, { path as webShopPath } from 'pages/WebShop';
import PrivateRoute from 'components/PrivateRoute';
import ScrollToTop from 'ScrollToTop';
import useGotoAppInstall from 'utils/useGotoAppInstall';
import Layout from 'components/Layout';
import PromoWidget from 'pages/PromoWidget';
import Document from 'pages/Registration/methods/Document';
import SelectMethod from 'pages/Registration/SelectMethod';
import Activation from 'pages/Registration/methods/Document/Activation';
import BankID from 'pages/Registration/methods/BankID';
import CoreId from 'pages/Profile/pages/CoreId';
import SellItem from 'pages/MyTickets/pages/SellItem';
import SellTickets from 'pages/MyTickets/pages/Sell';
import Details from 'pages/Event/pages/Details';
import ReservationCheckout from 'pages/Event/pages/ReservationCheckout';
import BuyTickets from 'pages/Event/pages/BuyTickets';
import PageNotFound from 'pages/PageNotFound';
import ForPromoter from 'pages/ForPromoter';
import Jumbotron from './pages/Jumbotron';
import JumbotronSK from './pages/JumbotronSK';

function App () {

    const dispatch = useDispatch();
    useGotoAppInstall();
    const location = useLocation();

    useEffect(() => {
        dispatch(checkAuth());
    }, [dispatch]);

    return (
        <React.Fragment>
            <ScrollToTop />
            {/* <Sizer /> */}
            <Layout>
                <Routes>
                    <Route index element={<Home />} />
                    <Route path='/events' element={<Event />}>
                        <Route path=':id' element={<Details />}>
                            <Route path={BuyTickets.path} element={<PrivateRoute element={BuyTickets} />} />
                        </Route>
                        <Route path={`:id${ReservationCheckout.path}`} element={<PrivateRoute element={ReservationCheckout} />} /> {/* not a good solution? */}
                    </Route>
                    <Route path={WebShop.path} element={<PrivateRoute element={WebShop} />} />
                    <Route path={PasswordRecovery.path} element={<PasswordRecovery />} />
                    <Route path={Registration.path} element={<Registration />}>
                        <Route index element={<SelectMethod />} />
                        <Route path={Document.path} element={<Document />} />
                        <Route path={Activation.path} element={<Activation />} />
                        <Route path={BankID.path} element={<BankID />} />                    
                        <Route path={BankID.loginPath} element={<BankID {...{login: true}} />} />
                    </Route>
                    <Route path={Help.path} element={<Help />} />
                    <Route path={Profile.path} element={<PrivateRoute element={Profile} />}>
                        <Route path={CoreId.path} element={<PrivateRoute element={CoreId} />} />
                    </Route>
                    <Route path={Tickets.path} element={<PrivateRoute element={Tickets} />}>
                        <Route path={SellTickets.path} element={<PrivateRoute element={SellTickets} />} />
                        <Route path={SellItem.path} element={<PrivateRoute element={SellItem} />} />                        
                    </Route>
                    <Route path={Notifications.path} element={<PrivateRoute element={Notifications} />} />
                    <Route path={Contacts.path} element={<Contacts />} />
                    <Route path={Privacy.path} element={<Privacy />} />
                    <Route path={Cookies.path} element={<Cookies />} />
                    <Route path={Terms.path} element={<Terms />} />
                    <Route path={ScanningPrivacy.path} element={<ScanningPrivacy />} />
                    <Route path={'/promo/:pid'} element={<PromoWidget />} />
                    <Route path={ForPromoter.path} element={<ForPromoter />} />
                    <Route path={JumbotronSK.path} element={<JumbotronSK />} />
                    <Route path={'*'} element={<PageNotFound />} />
                </Routes>
            </Layout>
        </React.Fragment>
    );
}

export default App;
